import ModalLogout from './ModalLogout';

export default ModalLogout;
